import { smoothScrollElementTo } from "@utils/smoothScrollElementTo";

/** 與 `_drop-down-option.scss` 的 `$drop-down-accordion-duration` 對齊並略加緩衝 */
const ACCORDION_TRANSITION_MS = 250;
const VIEW_PADDING = 12;

/**
 * 母頁面子選單手風琴展開後，若區塊超出 `.menu-bar__sidebarModal-scroll`
 * 可視範圍，則平滑捲動到該處（僅在必要時捲動）。
 * @param {HTMLElement | null | undefined} itemEl 手風琴列（li）
 */
export function scrollMenuBarAccordionIntoView(itemEl) {
  if (!itemEl || typeof itemEl.closest !== "function") return;

  const scrollRoot = itemEl.closest(".menu-bar__sidebarModal-scroll");
  if (!scrollRoot) return;

  let finished = false;

  const measureAndScroll = () => {
    if (finished) return;
    finished = true;

    const rootRect = scrollRoot.getBoundingClientRect();
    const itemRect = itemEl.getBoundingClientRect();
    const viewHeight = rootRect.height - VIEW_PADDING * 2;

    let delta = 0;
    // 展開後比可視區還高：對齊頂部，方便從頭看子項
    if (itemRect.height >= viewHeight) {
      delta = itemRect.top - rootRect.top - VIEW_PADDING;
    } else if (itemRect.bottom > rootRect.bottom - VIEW_PADDING) {
      delta = itemRect.bottom - rootRect.bottom + VIEW_PADDING;
    } else if (itemRect.top < rootRect.top + VIEW_PADDING) {
      delta = itemRect.top - rootRect.top - VIEW_PADDING;
    }

    if (Math.abs(delta) <= 1) return;

    smoothScrollElementTo(scrollRoot, scrollRoot.scrollTop + delta, {
      duration: 280,
    });
  };

  const wrappers = Array.from(itemEl.querySelectorAll(":scope > .submenu-wrapper"));

  const onTransitionEnd = (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.propertyName && event.propertyName !== "grid-template-rows") {
      return;
    }
    cleanup();
    requestAnimationFrame(measureAndScroll);
  };

  const cleanup = () => {
    wrappers.forEach((el) =>
      el.removeEventListener("transitionend", onTransitionEnd)
    );
    window.clearTimeout(fallbackId);
  };

  wrappers.forEach((el) =>
    el.addEventListener("transitionend", onTransitionEnd)
  );

  const fallbackId = window.setTimeout(() => {
    cleanup();
    requestAnimationFrame(measureAndScroll);
  }, ACCORDION_TRANSITION_MS);
}

/**
 * 從點擊事件目標找手風琴列並捲入可視區。
 * @param {EventTarget | null} eventTarget
 */
export function scrollMenuBarAccordionFromEvent(eventTarget) {
  const el =
    eventTarget && typeof eventTarget.closest === "function"
      ? eventTarget.closest("li.drop-down-item, li.submenu-group")
      : null;
  if (!el) return;
  scrollMenuBarAccordionIntoView(el);
}
